import { onMount, onDestroy, onView } from "@/modules/_";
import gsap from "@lib/gsap";
import { Scroll } from "@lib/scroll";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const maskIn = element.querySelector("[data-mask-in]");

  gsap.set(maskIn, {
    opacity: 0,
  });

  onMount(() => {
    gsap.set(maskIn, {
      opacity: 1,
    });

    gsap.from(maskIn, {
      yPercent: 100,
      duration: 1,
      ease: "smooth",
      stagger: 0.2,
    });
  });
}
